import { Check, Warning } from '@oresundsbron/icons';
import { constants } from '@oresundsbron/validators';
import { useTranslation } from 'next-i18next';
import { VerificationCodeResponseStatus } from './utils';

interface ResponseBannerProps {
  status: VerificationCodeResponseStatus;
  errorText: string;
  ns: string[];
}

export const CodeVerificationResponseBanner = ({
  status,
  errorText,
  ns,
}: ResponseBannerProps) => {
  const { t } = useTranslation(ns, {
    nsMode: 'fallback',
  });

  const getErrorMessage = (errorText: string) => {
    switch (errorText) {
      case constants.ACCOUNT_BLOCKED.value:
        return t(
          'form.sections.codeVerification.verificationError.accountBlocked'
        );
      case constants.CODE_LENGTH_INVALID.value:
        return t(
          'form.sections.codeVerification.verificationError.pastedCodeInvalid'
        );
      default:
        return t('form.sections.codeVerification.verificationError.default');
    }
  };

  const showBanner = () => {
    const commonClasses = 'flex items-center text-xs py-3 px-4';
    switch (status) {
      case VerificationCodeResponseStatus.newCodeSent:
        return (
          <div className={`${commonClasses} bg-green-100 text-green-800`}>
            <Check className="mr-4" />{' '}
            {t('form.sections.codeVerification.newCodeSent')}
          </div>
        );
      case VerificationCodeResponseStatus.error:
        return (
          <div className={`${commonClasses} bg-red-100 text-red-700`}>
            <Warning className="mr-4" /> {getErrorMessage(errorText)}
          </div>
        );
      default:
        return <></>;
    }
  };
  return showBanner();
};

export default CodeVerificationResponseBanner;
